export const FILTER_LIST = {
  review: {
    name: "REVIEW",
    code: "30093",
    paramKey: "review"
  },
  category: {
    name: "CATEGORY",
    code: "30020",
    paramKey: "categories"
  },
  subject: {
    name: "SUBJECT",
    code: "30021",
    paramKey: "subjects"
  },
  level: {
    name: "LEVEL",
    code: "30022",
    paramKey: "levels"
  },
  running_time: {
    name: "RUNNING_TIME",
    code: "30025",
    paramKey: "runningTime"
  },
  contents: {
    name: "CONTENTS",
    code: "30031",
    paramKey: "resourceTypes"
  },
  price: {
    name: "PRICE",
    code: "30037",
    paramKey: "free"
  },
  course_language: {
    name: "COURSE_LANGUAGE",
    code: "30040",
    paramKey: "courseLanguageCode"
  },
  subtitle_language: {
    name: "SUBTITLE_LANGUAGE",
    code: "30041",
    paramKey: "subtitleLanguageCode"
  }
};
